module.exports = __webpack_public_path__ + "img/2024-09-19b_1.5860e046.jpg";